angular.module( 'acme.view.application.programs.detail.dependents', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.programs.detail.dependents.controllers',
  'acme.common.service.api'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var programsDetailDependents = {
        name: 'application.programsDetail.dependents',
        url: '/dependents',
        views: {
          "subview-main": {
            controller: 'ProgramsDetailDependentsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/programs/detail/dependents/dependents.tpl.html'
          }
        },
        data: {
          pageTitle: 'Dependents ',
          pageClass: 'application application-programs-detail'
        },
        resolve: {
          ResolveTemplatesData: ['ApiService', 'HelpersService', function(ApiService, HelpersService) {
            return ApiService.program.names(false, HelpersService.getPaginator());
          }],
          ResolveDependentsData: ['$stateParams', 'ApiService', function($stateParams, ApiService) {
            return ApiService.program.dependents.list($stateParams.id);
          }]
        }
      };

    $stateProvider
      .state(programsDetailDependents);
});
